/* angular:styles/component:css;2f5aeccb011416e1a91b7560e480f3c854efa06c9b7c2bb70af9fa7b63bac50c;/src/src/app/edge/live/Controller/Evse/pages/forecast/forecast.ts */
.ion-justify-with-space-between ion-row > ion-col:nth-child(2) {
  text-align: right;
}
form {
  align-content: center !important;
}
/*# sourceMappingURL=forecast.css.map */
